import { AfterViewInit, Directive, ElementRef } from '@angular/core';

@Directive({
    selector: '[autofocus]',
    standalone: false
})
export class AutofocusDirective implements AfterViewInit {
    constructor(private readonly host: ElementRef) {}

    ngAfterViewInit() {
        this.host.nativeElement.focus();
    }
}
